import * as types from '../types/actionTypes/productSegmentsType';

const productSegments = null as string[] | null;
const initialState = productSegments;

type State = typeof initialState;

export const productSegmentsReducer = (
    state: State = initialState,
    action: types.ProductSegmentsAction
) => {
    if (action.type === types.GET_PRODUCT_SEGMENTS)
        return action.productSegments;

    return state;
};